import DaysOfWeek from './DaysOfWeek';

export default DaysOfWeek;
